<template>
    <span>
    <v-dialog
            v-model="value"
            max-width="520"
    >
        <v-card>
            <v-card-title class="headline"><span v-html="$t('cancelSubscriptionDialog.title')"></span>
</v-card-title>

            <v-card-text>
              <span v-html="$t('cancelSubscriptionDialog.content')"></span>


                <div style="margin-top:20px;min-height:230px;">
                    <v-carousel v-if="!loading" :show-arrows="false" hide-delimiters ref="carousel"
                                height="height: 186px;">
                        <v-carousel-item>

                            <div class="col-12" v-for="(reason,index) in cancelationReasons" :key="index"
                                 style="padding:0 0 5px 0;">
                                <div class="v-card v-sheet v-sheet--outlined theme--light">
                                    <a @click="nextReasons(reason)"
                                       class="v-list-item--doc v-list-item v-list-item--link theme--light primary--text"
                                       tabindex="0">
                                        <div class="v-avatar v-list-item__avatar indigo darken-1"
                                             style="height: 40px; min-width: 40px; width: 40px;">
                                            <i aria-hidden="true"
                                               :class="`v-icon notranslate mdi mdi-${reason.avatar}  theme--dark`"></i>
                                        </div>
                                        <div class="v-list-item__content">
                                            <div class="v-list-item__title">
                                                <span v-text="reason.text"></span></div>

                                        </div>
                                        <div class="v-list-item__action">
                                            <i aria-hidden="true"
                                               class="v-icon notranslate mdi mdi-arrow-right theme--light"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <v-btn @click="completed({text: 'Not willing to share'})"
                                   text style="margin-top:5px;margin-left:-5px;color:rgba(0, 0, 0, 0.87);"><span
                                    v-html="$t('cancelSubscriptionDialog.feedbackNotWillingToShare')"></span>
</v-btn>

                        </v-carousel-item>
                        <v-carousel-item>

                            <div class="col-12" v-for="(reason,index) in nextCancelationReasons" :key="index"
                                 style="padding:0 0 5px 0;">
                                <div class="v-card v-sheet v-sheet--outlined theme--light">
                                    <a @click="completed({text: reason.textEn})"
                                       class="v-list-item--doc v-list-item v-list-item--link theme--light primary--text"
                                       tabindex="0">
                                        <div class="v-avatar v-list-item__avatar indigo darken-1"
                                             style="height: 40px; min-width: 40px; width: 40px;">
                                            <i aria-hidden="true"
                                               :class="`v-icon notranslate mdi mdi-${reason.avatar}  theme--dark`"></i>
                                        </div>
                                        <div class="v-list-item__content">
                                            <div class="v-list-item__title">
                                                <span v-text="reason.text"></span></div>

                                        </div>

                                    </a>
                                </div>
                            </div>
                            <v-btn text @click="previousResons"
                                   style="margin-top:5px;margin-left:-5px;color:rgba(0, 0, 0, 0.87);"> <v-icon>mdi-chevron-left</v-icon>Back</v-btn>

                        </v-carousel-item>
                    </v-carousel>


                    <v-progress-circular
                            v-if="loading"
                            style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; margin: auto;"
                            :size="70"
                            :width="7"
                            color="red"
                            indeterminate
                    ></v-progress-circular>

                </div>


            </v-card-text>

            <v-card-actions style="position: relative; z-index: 9999;">
                <v-spacer></v-spacer>

                <v-btn
                        color=" darken-1"
                        text
                        @click="close"
                        style="z-index:9999"
                >
                    <span v-html="$t('cancelSubscriptionDialog.close')"></span>

                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
        <v-snackbar
                v-model="snackbar"
        >
          <span v-html="$t('cancelSubscriptionDialog.subscriptionCancelled')"></span>


      <template v-slot:action="{ attrs }">
        <v-btn
                color="red"
                text
                v-bind="attrs"
                @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar></span>
</template>

<style>


</style>

<script>
    import config from '../config'
    import i18n from "@/i18n";

    export default {
        name: 'Modal_AccountPayment',
        props: ['value', 'signInToken'],
        data: () => ({
            nextCancelationReasons: [],
            loading: false,
            snackbar: false
        }),
        computed: {
            cancelationReasons() {
                return [
                    {
                        avatar: 'application-cog',
                        text: i18n.t('cancelSubscriptionDialog.feedbackTechnicalIssueTitle'),
                        textEn: 'Technical issue',
                        reasons: [
                            {
                                avatar: 'map-marker-off',
                                text: i18n.t('cancelSubscriptionDialog.feedbackUnsupportedCountry'),
                                textEn: 'Couldn\'t connect from unsupported country'
                            },
                            {
                                avatar: 'quality-low',
                                text: i18n.t('cancelSubscriptionDialog.feedbackQualityPoor'),
                                textEn: 'Game quality was poor or unplayable'
                            },
                            {
                                avatar: 'speedometer-slow',
                                text: i18n.t('cancelSubscriptionDialog.feedbackInternetConnection'),
                                textEn: 'Internet connection is not fast enough'
                            },
                            {
                                avatar: 'dots-horizontal',
                                text: i18n.t('cancelSubscriptionDialog.feedbackOther'),
                                textEn: 'Other'
                            }

                        ]
                    },
                    {
                        avatar: 'emoticon-confused-outline',
                        text: i18n.t('cancelSubscriptionDialog.feedbackServiceNotAsExpected'),
                        textEn: 'Service not as expected',
                        reasons: [
                            {
                                avatar: 'quality-low',
                                text: i18n.t('cancelSubscriptionDialog.feedbackQualityPoor'),
                                textEn: 'Game quality was poor or unplayable'
                            },
                            {
                                avatar: 'google-controller-off',
                                text: i18n.t('cancelSubscriptionDialog.feedbackNotIncludeStadia'),
                                textEn: 'Does not include Stadia™ subscription'
                            },
                            {
                                avatar: 'apple',
                                text: i18n.t('cancelSubscriptionDialog.feedbackNoIos'),
                                textEn: 'Does not support iOS'
                            },
                            {
                                avatar: 'dots-horizontal',
                                text: i18n.t('cancelSubscriptionDialog.feedbackOther'),
                                textEn: 'Other'
                            }

                        ]
                    },
                    {
                        avatar: 'account-cash', text: i18n.t('cancelSubscriptionDialog.feedbackToExpensive'),
                        textEn: 'Service is too expensive'



                    }
                ];
            }
        },
        methods: {
            async completed(secondarySelectedReason) {


                let reasonText = secondarySelectedReason.text;

                if (this.selectedReason) {

                    reasonText = this.selectedReason.text + ' - ' + reasonText;

                }

                this.loading = true;

                await fetch(`${config.serverURL}/account/cancelSubscription`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({jwtToken: localStorage.signInToken, reason: reasonText})
                });

                this.snackbar = true;
                this.$emit('completed', reasonText);
                this.close();


            },
            nextReasons(reason) {

                this.selectedReason = reason;

                if(reason.reasons){
                    this.nextCancelationReasons = reason.reasons;
                    this.$refs.carousel.next();
                }else{

                    this.completed({text: reason.textEn});

                }

            },
            previousResons() {
                this.selectedReason = undefined;
                this.$refs.carousel.prev();
            },
            close() {
                this.$emit('input', false);
            }

        }


    };
</script>
